<div class="v3-filter-shell">
  <div class="v3-filter-shell__header">
    <span class="v3-filter-shell__title">{{ title }}</span>
    <div class="v3-filter-shell__controls">
      <ng-content select="[shell-controls]"></ng-content>
    </div>
    <ptl-button
      class="v3-filter-shell__delete"
      [type]="'link-neutral'"
      [size]="'sm'"
      [icon]="LucideTrash2"
      [ariaLabel]="'translations.global.button.delete' | transloco"
      (clicked)="deleted.emit()"
    ></ptl-button>
  </div>
  <div class="v3-filter-shell__body">
    <ng-content></ng-content>
  </div>
  <div class="v3-filter-shell__footer">
    <ptl-button
      class="v3-filter-shell__apply"
      [type]="'primary'"
      [size]="'sm'"
      [text]="'translations.global.button.apply' | transloco"
      (clicked)="applied.emit()"
    ></ptl-button>
  </div>
</div>
